import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useLocation} from "react-router-dom";
import ListView from "../../components/ContentDisplay/ListView";
import ControllerCard from "../Controllers/controllersTable/controllerCard";
import {
  requestFavourites,
  saveSelectedControler,
} from "../../redux/Actions/controllers.actions";
import {getSiteAndLocationForFavouriteController} from "../../redux/Actions/sites.actions";
import {getFavourites} from "../../redux/Selectors/controllers.selectors";
import "./FavTable.scss";

const TEMP_LIST_HEADERS = [
  "name",
  "serial",
  "claimed_by",
  "site_name",
  "location_name",
  "date_claimed",
  "properties.state.state",
  "alarm",
];

const FavSystemTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const controllers = useSelector(getFavourites);

  useEffect(() => {
    dispatch(requestFavourites());
  }, [dispatch]);

  const handleRowSelection = (selectedRow) => {
    dispatch(
      getSiteAndLocationForFavouriteController(
        selectedRow.site_id,
        selectedRow.location_id
      )
    );
    dispatch(saveSelectedControler(selectedRow));
    navigate(`/app/appliance/${selectedRow.mac}`, {
      state: {previous: location.pathname},
    });
  };

  return (
    <div className="table-container">
      <div
        style={{
          fontSize: "25px",
          color: "#073e57",
          paddingBottom: "8px",
        }}
        className="roboto-bold"
      >
        Favourite Appliance(s)
      </div>
      <ListView
        cardContent={ControllerCard}
        listHeaders={TEMP_LIST_HEADERS}
        listItems={controllers}
        noDataText={"NO FAVOURITE SELECTED"}
        onSelectRow={handleRowSelection}
        rowClickable
        tableName="favourite-controllers"
      />
    </div>
  );
};

export default FavSystemTable;
